import choosePlan from '../common/adhesion/choose-plan.vue'
import chooseRecharge from '../common/adhesion/choose-recharge.vue'
import userData from '../common/adhesion/user-data.vue'
import companyData from '../common/adhesion/company-data.vue'
import vehicles from '../common/adhesion/vehicles.vue'
import GenericSummary from '../common/generic-summary.vue'
import * as obj from '../common/adhesion/objects'
import Sales from '../../services/sales'
import C from '../common/constantes'
import successPage from '../common/adhesion/success.vue'
import errorPage from '../common/adhesion/error.vue'
import messageDialog from '../../components/message-dialog';
import * as Utils from '../../utils';
import {
  EventBus
} from '../../event-bus'
import adhesionConfirm2fa from "./adhesion-confirm-2fa.vue"

const subs = ['', 'Queremos saber mais sobre você, por gentileza, informe os seus dados abaixo:', 'Cadastre os veículos que irão utilizar o plano:', 'Confira e confirme os dados do seu pedido:', ''];

export default {
  props: ['type'],
  data() {
    return {
      checkPlanArray: [31, 32, 5, 64],
      step: 0,
      subtitle: subs,
      msgError: undefined,
      loading: undefined,
      success: false,
      code: undefined,
      planId: undefined,
      lead: undefined,
      minValue: 200000,
      promotionCode: undefined,
      salesOrder: undefined,
      request: {
        "_interface": window.document.webview ? "MOBILE" : "WEBSITE",
        account: obj.account(),
        address: obj.address(),
        contract: obj.contract(),
        changeFlagEmail: obj.contract().changeFlagEmail,
        listVehicle: {
          vehicle: []
        },
        value: undefined,
        whereToDelivrey: "0",
        promotionCode: undefined,
        shipmentType: undefined,
      },
      salesResponse: undefined,
      validacaoFraude:undefined,
      isMobile: false,
      isRechargeSelected: false,
    };
  },

  computed: {
    vehicles() {
      return this.request.listVehicle.vehicle;
    },
    checkPlan() {
      return this.checkPlanArray.includes(this.planId);
    },
    qtdAllowed() {
      return C.LIMIT_VEHICLES;
    },

    isPJ() {
      if (this.lead)
        return this.lead.typeTaxId == 'COMPANY';

      return C.isPJ(this.planId);
    },
    isCaminhoParana() {
      return !!this.lead;
    },
    plan() {
      return this.$store.getters.getPlanById(this.planId);
    },
    planName() {
      return this.plan && this.plan.name;
    },
    newAdhesionTax() {
      return this.$store.getters.getNewAdhesionTax(this.planId);
    },
    newVehicleTax() {
      return this.$store.getters.getNewVehicleTax(this.planId);
    },
    guaranteeTax() {
      return this.$store.getters.getGuaranteeTax(this.planId);
    },
    account() {
      return this.request.account;
    },

    address() {
      return this.request.address;
    },

    contract() {
      return this.request.contract;
    }

  },

  created() {

    this.$store.commit('resetLoading');

    if (window.ga) window.ga('send', 'pageview', 'adesao/etapa1');

    this.lead = sessionStorage.getItem('lead') ? JSON.parse(sessionStorage.getItem('lead')) : undefined;
    if (this.lead)
      this.lead.plates = this.lead.listVehicle.toUpperCase().replace(/(\w{3})(\d{4})/g, '$1-$2').split(/;/);

    sessionStorage.removeItem('lead');
    sessionStorage.removeItem("showed-reprocess");

    if (!this.$route.query.planId && !this.lead) {
      this.$router.push({
        name: 'home'
      });
      return;
    }

    this.planId = parseInt(this.$route.query.planId || 36);
    this.$store.commit('currentPlanId', this.planId);

    if (!this.account || !this.account.taxIdNumber) {
      this.request.account = this.isPJ ? obj.companyAccount() : obj.account();

      if (this.lead) {
        this.request.account.taxIdNumber = this.lead.taxpayerIdNumber;
        this.request.account.accountAuthentication.login = this.lead.contactEmail;
        this.address.zipCode = this.lead.zipCode;
        let leadTels = this.lead.phone ? this.lead.phone.split(';') : [];

        if (leadTels.length && leadTels[0].length > 2) {
          leadTels[0] = leadTels[0].replace(/[^0-9]/g, '').replace(/^0/, '');
          this.request.account.dddCellphone = leadTels[0].substring(0, 2);
          this.request.account.nroCellphone = leadTels[0].substring(2);
        }

        if (this.isPJ) {
          this.request.account.company.companyName = this.lead.companyName;
          this.request.account.company.companyTradeName = this.lead.companyName;
          this.request.account.taxIdNumberFormatted = this.lead.taxpayerIdNumber.replace(/(\w{2})(\w{3})(\w{3})(\w{4})(\w{2})/, '$1.$2.$3/$4-$5');
        } else {
          this.request.account.person.fullName = this.lead.companyName;
          this.request.account.taxIdNumberFormatted = this.lead.taxpayerIdNumber.replace(/(\w{3})(\w{3})(\w{3})(\w{2})/, '$1.$2.$3-$4');
        }
      }
    }


    EventBus.$on('cleanErrors', () => {
      this.msgError = undefined;
    });

  },

  mounted: function () {

      if(window.innerWidth <= 769) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
     window.addEventListener('resize', () => window.innerWidth <= 769 ? this.isMobile = true : this.isMobile = false );

    let vm = this;
    let el = $(this.$el);
    el.find('.question-box h4').click(function () {
      el.find('.open').removeClass('open');
      $(this).find('i').addClass('open');
      $(this).parent().find('.answer-box').addClass('open');
    });
  },

  methods: {

    handleValorSelecionado(valor) {
      if (!valor) {
        this.isRechargeSelected = false;
      } else {
        this.isRechargeSelected = true;
      }

    },

    checkTypePlan() {
      if (this.planId >= 35 && this.planId <= 38) {
        return;
      }

      this.request.account = this.isPJ ? obj.companyAccount() : obj.account();
      this.request.account.taxIdNumber = this.$route.query.taxIdNumber;
      this.request.account.taxIdNumberFormatted = this.formatTaxId(this.$route.query.taxIdNumber);
    },

    nextStep() {
      this.msgError = undefined;
      $('body').stop().animate({
        scrollTop: 0
      }, '500', 'swing');
      switch (this.step) {
        case 0:
          let p;
          let refPlan;
          if (this.planId == 31 || this.planId == 32 || this.planId == 5 || this.planId == 64) {
            refPlan = this.$refs.chooseRecharge;
            this.loading = p = refPlan.validateAll();
          } else {
            refPlan = this.$refs.choosePlan;
            this.loading = p = refPlan.validateAll();
          }
          p.then(r => {
            this.sendPageView();
            this.checkTypePlan();
            if (refPlan && refPlan.getCoupon) {
              const couponValue = refPlan.getCoupon();
              if (couponValue) {
                this.request.coupon = couponValue;
              } else {
                delete this.request.coupon;
              }
            }
            this.step += 1;
          }).catch(err => {
            if (err === 'Cupom inválido') {
              this.msgError = 'Cupom inválido. Verifique o código informado.';
            } else if (this.planId == 2 || this.planId == 3) {
              this.msgError = 'Infome um CPF ou CNPJ válido para continuar';
            } else {
              this.msgError = 'Por favor verifique o valor de recarga';
            }
          });
          break;
        case 1:
          this.loading = this.$refs.userData
            .validateAll()
            .then((r) => {
              if(this.$refs.confirm2fa.isOK()) {
                this.sendPageView();
                this.contract.plan.name = this.plan.name;
                this.step += 1;
              }
            })
            .catch((err) => {
              this.msgError = "Por favor verifique os campos com erro";
            });
          break;
        case 2:
          this.sendPageView();
          if (this.vehicles.length > 0 || this.planId == 6 || this.planId == 8) {
            this.generateSalesOrder();
            this.step += 1;
          } else {
            this.msgError = 'Adicione ao menos um veículo para continuar';
          }
          break;
        case 3:
          this.sendPageView();
          break;
      }
    },

    sendPageView() {
      if (window.ga) window.ga('send', 'pageview', 'adesao/etapa' + (this.step + 2));

    },
    backStep() {
      if (this.step == 0) {
        this.cancelar();
        return;
      }

      if (this.step == 1) {
        delete this.request.coupon;
      }

      this.msgError = undefined;
      $('body').stop().animate({
        scrollTop: 0
      }, '500', 'swing');
      this.step -= 1;
    },
    cancelar() {
      messageDialog.show({
        title: 'Cancelar Adesão',
        message: 'Deseja cancelar a adesão?',
        type: 'OK-CANCEL-ADHESION'
      }).then(res => {
        if (res == 'OK') {
          sessionStorage.removeItem("lead");
          if (window.ga) window.ga('send', 'pageview', 'adesao/cancelou');
          if (this.planId && this.getKindPlan(this.planId) == 'RNTRC')
            this.$router.push({
              name: 'home'
            });
          else if (this.isPJ)
            this.$router.push({
              name: 'services-b2b'
            });
          else
            this.$router.push({
              name: 'services-b2c'
            });
        }
      });

    },
    doRequest() {
      delete this.request.contractPaymentMethod;
      delete this.request.contract.paymentMethods;

      let url_atual = window.location.href;

      if (url_atual != "") {
        var regexp = new RegExp(/\S+pdv\S+/i);
        var n = regexp.test(url_atual);
        if (n) {
          this.request["promotionCode"] = "GRAALKM29";
          this.request["logisticsDistribution"] = "FOB";
        }
      }

      if (Utils.isCaminhoParana(this.planId)) {
        this.request["promotionCode"] = "CAMINHOSDOPARANA";
        this.request["logisticsDistribution"] = "FOB";
      } else if (this.promotionCode) {
        this.request["promotionCode"] = this.promotionCode;
      }

      if (this.request["whereToDelivrey"] != "0") {
        this.request["promotionCode"] = this.request["whereToDelivrey"];
        this.request["logisticsDistribution"] = "FOB";
      }

      if (this.request["shipmentType"] == 3) {
        this.request["logisticsDistribution"] = "FOB";
      };

      this.request.contract.lcFlag = this.request.contract.lcFlag ? 1 : 0;

      this.loading = Sales.adhesion(this.request).catch(err => {
        const data = (err && err.data) || {};
        const status = data.status || {};
        this.code = status.code;
        this.msgError = status.message || data.message || 'Não foi possível concluir a adesão.';
        this.salesResponse = undefined;
        if (window.ga) window.ga("send", "pageview", "adesao/erro");
        $("body").stop().animate({ scrollTop: 0 }, "500", "swing");
      });
      this.$store.dispatch('loading', this.loading);
    },
    nextParana(plan) {
      if (plan == 'man') {
        this.contract.plan.planId = this.planId = this.lead.typeTaxId == 'COMPANY' ? 37 : 35;
      } else {
        this.contract.plan.planId = this.planId = this.lead.typeTaxId == 'COMPANY' ? 38 : 36;
      }

      this.$store.commit('currentPlanId', this.contract.plan.planId);

      this.nextStep();
    },
    startRequest() {
      this.$refs.GenericSummary.getInfos().then(r => {
        this.request.address      = r.address;
        this.promotionCode        = r.promotionCode;
        this.request.shipmentType = r.shipmentType;
        this.doRequest();
      });
    },

    generateSalesOrder() {

      let value = this.vehicles.length * this.newAdhesionTax + this.vehicles.length * this.guaranteeTax;

      this.salesOrder = {
        "_interface": "WEBSITE",
        "planId": this.planId,
        "status": null,
        "type": "ADHESION",
        "salesType": "ADHESION",
        "taxpayerIdSeller": null,
        "promotionCode": null,
        "price": value,
        "logisticsDistribution": null,
        "bankBillUrl": null,
        "transactionPassageId": null,
        "vehicleId": null,
        "shipment": null,
        "vehicles": this.vehicles,
        "shipmentType": this.request.shipmentType,
        "products": [{
          "productId": 1,
          "productName": "ADESÃO",
          "valueUnit": this.newAdhesionTax,
          "quantity": this.vehicles.length,
          "valueTotal": value
        }],
      };

      if (this.isCaminhoParana) {
        this.salesOrder["promotionCode"] = "CAMINHOSDOPARANA";
        this.salesOrder["logisticsDistribution"] = "FOB";
      } else if (sessionStorage.getItem('promotionCode')) {
        this.promotionCode = sessionStorage.getItem('promotionCode');
        this.salesOrder["promotionCode"] = this.promotionCode;
      }

      if (true) {
        if (this.planId != 6) {
          this.salesOrder.products.push({
            "productId": 2,
            "productName": "RECARGA",
            "valueUnit": this.contract.rechargeValue,
            "quantity": 1,
            "valueTotal": this.contract.rechargeValue
          });
          this.salesOrder.products.push({
            "productId": 3,
            "productName": "TAXA DE RECARGA",
            "valueUnit": this.contract.tax,
            "quantity": 1,
            "valueTotal": this.contract.tax
          });

          this.salesOrder.price += this.contract.tax + this.contract.rechargeValue
        }
      }
    },
  },
  components: {
    choosePlan,
    chooseRecharge,
    userData,
    vehicles,
    successPage,
    errorPage,
    companyData,
    GenericSummary,
    adhesionConfirm2fa
  },
};



// WEBPACK FOOTER //
// ./src/pages/external/adhesion.js